import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';

let env = runtimeEnv('B2B_API_BASE_URL');

export const notificationApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${API_ENDPOINT.Notification.api + '?id=' + data?.id + '&page=' + page + '&pageSize=' + (data.pageSize ? data.pageSize : '') + '&isB2B=true'}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const notificationCountApi = async (data) => {
  let url = `${env}${API_ENDPOINT.Notification.countApi + '/' + data?.id + '?isB2B=true'}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const notificationSeenApi = async (data) => {
  let url = `${env}${API_ENDPOINT.Notification.seenApi + '/' + data?.id + '?isB2B=true'}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
